// extracted by mini-css-extract-plugin
module.exports = {"button":"BackButton_button__2RjDv","disabled":"BackButton_disabled__3NSw-","icon":"BackButton_icon__zDuF-"};